// **** import modules ****
// import $ from "jquery";
import moment from "moment";
import app, { csl, vuwer } from "@@assets/scripts/common";
import "./_topics";

// **** process ****
app.gaAutoSendPageview = false;

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

vuwer.setProp({
	async onChangeState(state) {
		csl.log.red("vuwer.changeState", state);
		
		const flg = {
			popstate: !!state.popstate
		};
		delete state.popstate;
		
		// [ym]
		const nowYM = moment().format("YYYY-MM");
		if(state.ym === nowYM) {
			delete state.ym;
		}
		
		//// history change ////
		const hstry = (!app.isReady || flg.popstate) ? "replaceState" : "pushState";
		app[hstry](state);
		
		//// render page ////
		if(app.isReady) {
			// フッターを隠して子Vuwを更新
			// vuwer.get("siteFooter").$self.removeClass("fixed-bottom");
			
			const $pageMain = vuwer.get("pageMain").$self;
			$pageMain.css( "min-height", $pageMain.outerHeight() );
		}
		
		//// async process ////
		const topicsSection = this.get("topicsSection");
		if(topicsSection) {
			const ym = state.ym || nowYM;
			await topicsSection.setState({ ym });
		}
		
		// // [set scroll]
		// this._scrollBase = vuwer.get("pageMain").$self.offset().top;
		// this._scrollBase -= vuwer.get("body").smoothScrollBuffer || 0;
		// if(this.$window.scrollTop() > this._scrollBase) {
		// 	await new Promise(resolve => {
		// 		$(document.scrollingElement).animate({
		// 			scrollTop: this._scrollBase
		// 		}, "fast", resolve);
		// 	});
		// }
		
		if(app.isReady) {
			// フッターを再表示
			vuwer.get("pageMain").$self.css("min-height", "");
			// vuwer.get("siteFooter").$self.addClass("fixed-bottom");
		}
	}
});

app.exec();
